import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

const ContactSection = ({ data }) => (
    <Container fluid className="contact-section">
        <Row>
            <Col xs={0} sm={0} md={0} lg={3} />
            <Col xs={12} sm={12} md={7} lg={5}>
                <div className="form">
                    <h1 className="h2 mb-5">{data.contact_form_header}</h1>
                    <p className="text-m mb-5">{data.contact_form_description}</p>
                    <flotiq-form />
                </div>
            </Col>
            <Col xs={12} sm={12} md={5} lg={4}>
                <div className="light-blue-background right-info">
                    <img
                        src={data.contact_help_section_image_desktop[0]?.localFile?.publicURL}
                        alt={data.contact_help_section_image_alt}
                        className="d-none d-md-block"
                    />
                    <img
                        src={data.contact_help_section_image_mobile[0]?.localFile?.publicURL}
                        alt={data.contact_help_section_image_alt}
                        className="d-block d-md-none"
                    />
                    {data.contact_help_section_list.map((listItem, index) => (
                        <div
                            key={index}
                            className="text-s checked-text"
                            dangerouslySetInnerHTML={{ __html: listItem.list_item }}
                        />
                    ))}
                </div>
            </Col>
        </Row>
    </Container>
);

export default ContactSection;
